import './userMarginFees.css';
import { launchError, launchSuccess } from 'components/notifications';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { deleteUserPriorityFees, updateUserPriorityFees } from 'services/userServices';
import { fetchTickers } from 'services/tickersServices';
import { removeExchangeFromTicker } from 'utils/display';



const UserMarginFees = ({ user, id, setUserData, userData }) => {

  const [isLoading, setLoading] = useState(false)
  const [searched, setSearched] = useState('');
  const [searchedTickers, setSearchedTickers] = useState([]);
  const [priorityTickers, setPriorityTickers] = useState([...userData.priority_margin_fees]);
  const { t } = useTranslation();



  const handleSearchTicker = async (search) => {
    try {
      setSearched(search)
      setLoading(true)
      let response = []
      if (search?.length > 0)
        response = await fetchTickers({ user, page: 0, limit: 10, leverage: true, search })
      setSearchedTickers(response)
    } catch (err) {
      console.error(err)
    } finally {
      setLoading(false)
    }
  }

  const handleSelectTicker = (selectedTicker) => {
    const alreadyInList = priorityTickers.some(({ ticker }) => ticker === selectedTicker.ticker)
    if (!alreadyInList) {
      priorityTickers.push({ ticker: selectedTicker.ticker, percentage: 0 });
      setSearchedTickers([])
      setSearched('')
    }
  }

  const updatePriorityFees = async () => {
    try {
      setLoading(true)
      const result = await updateUserPriorityFees(user, id, {tickers: priorityTickers})
      setUserData({ ...userData, priority_margin_fees: result })
      launchSuccess(t('notifications.users.userById.priority_fees.update.success'))
    } catch (error) {
      launchError(t('notifications.users.userById.priority_fees.update.error'))
    } finally {
      setLoading(false)
    }
  }

    const deletePriorityFees = async (symbol) => {
    try {
      setLoading(true)
      await deleteUserPriorityFees(user, id, symbol)
      const newPriorities = [...userData.priority_margin_fees].filter(({ticker}) => ticker !== symbol);
      setUserData({ ...userData, priority_margin_fees: newPriorities })
      setPriorityTickers(newPriorities)
      launchSuccess(t('notifications.users.userById.priority_fees.delete.success'))
    } catch (error) {
      launchError(t('notifications.users.userById.priority_fees.delete.error'))
    } finally {
      setLoading(false)
    }
  }

  const isValid = () => priorityTickers.reduce((acc, { percentage }) => acc && !isNaN(percentage) && percentage > 0 && percentage <= 100, true)


  const handleRemoveTicker = (tickerSymbol) => {
    const updatedTickers = priorityTickers.filter(({ ticker }) => ticker !== tickerSymbol);
    setPriorityTickers(updatedTickers)
  }

  const handlePercentage = (index, e) => {
    const updatedTickers = [...priorityTickers];
    updatedTickers[index].percentage = Number(e.target.value)
    setPriorityTickers(updatedTickers)
  }

  return <div className='userData_case'>
    <p className='user_doc_title'>Réduction sur ticker margin :</p>
    <input className="psform-input-text" type="text" name="products" placeholder="Rechercher un ticker" value={searched} onChange={(e) => handleSearchTicker(e.target.value)} />

    {
      searchedTickers.length > 0 && (
        <div className="ticker-results">
          {searchedTickers.map((ticker, index) => (
            <div key={index} className="psform-ticker-box pointer" onClick={() => handleSelectTicker(ticker)}>
              <img className="ticker-img" src={`https://cdn.goliaths.io/stocks/${removeExchangeFromTicker(ticker.ticker)}.png`} alt="" />
              <span className="psform-input-label">{ticker.name}</span>
            </div >
          ))}
        </div>
      )
    }

    <div className="select-ticker-product">
      {
        priorityTickers.map(({ ticker, percentage }, index) => (
          <div key={index} className="priority_fees_row_box">
            <div className="ticker-desc">
              <img className="ticker-img" src={`https://cdn.goliaths.io/stocks/${removeExchangeFromTicker(ticker)}.png`} alt="" />
              <span className="psform-input-label">{ticker}</span>
            </div>
            <input
              id='free_transactions_input'
              type='number'
              value={percentage}
              className='userData_free_transactions_input'
              onChange={(e) => handlePercentage(index, e)}
            />
            <span onClick={() => deletePriorityFees(ticker)} className="pointer delete-ticker-button">supprimer</span>
          </div >
        ))
      }
    </div>


    <div className="priority_fees_submit_box">
      <button className="priority_fees_submit_button" disabled={!isValid()} onClick={updatePriorityFees} >Sauvegarder et continuer</button>
    </div>
  </div>

}


export default UserMarginFees